import { createContext } from 'react';

import { ClientStatusContext as ClientStatusContextProps } from './interfaces';

export const ClientStatusContext = createContext<ClientStatusContextProps>({} as ClientStatusContextProps);
